
const defaultState = function () {
  return {
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'download_order_quantity',
    // 検索条件
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
